import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { validarIdentificacion } from "app/logic/cliente";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";

type Entity = models.ContactoCliente;
export interface ContactoClienteParams {
    /**Id de la dirección padre se usa para validar la unicidad del registro */
    idDireccion: number;
}
export interface Props extends kea.ModalProps<Entity, boolean, ContactoClienteParams> {

}

/**
* Modal de edición para un ContactoCliente
*/
export class ContactoClienteEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    idDireccion = (props: Props) => props.params.idDireccion;
    datosRep = createSelectorRx(this.value, this.idDireccion, (value, idDireccion) => ({ idContacto: value.IdRegistro, idDireccion }));

    errores = createSelectorRx(this.value, this.datosRep, (value, datosRep) => {
        const rules: validation.Rules<Entity> = {
            Nombre: validation.required,
            Identificacion: x => true//validarIdentificacion(x.Identificacion, datosRep, resources.ContactoCliente)
        }
        return validation.getErrors(rules, value);
    });

    hasError = createSelectorRx(this.errores, errores => validation.hasError(errores));

    getField = formfields(() => this.props, () => this.errores(this.props));

    get rules(): validation.Rules<Entity> {
        return {
            Nombre: validation.required
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Check = getField(kea.Checkbox);
        const Identificacion = getField(IdentificacionComponent);
        const hasError = this.hasError(this.props);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Contacto"
            >

                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    //<Text field="Telefono" label="Teléfono" />,
                    <Text field="Email" label="Email" />,
                    <Check field="AutorizadoRecibir" label="Autorizado para recibir" />
                ])}

            <Identificacion field="Identificacion" datosRep={this.datosRep(this.props)} resourceRep={resources.ContactoCliente}   ocultarRFC={true} />
           
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/contactos/edit.tsx